/*jshint esversion: 6 */
/*jshint sub:true*/

import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

// const isLightTheme = localStorage.getItem('is_light_theme');

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#000000', // black
        'not-primary': '#FFFFFF', // white
        secondary: '#BDBDBD',
        'color-0': '#BDBDBD', // grey lighten-1
        'color-1': '#FFFFFF', // white
        'color-1-5': '#EEEEEE', // grey lighten-3
        'color-2': '#E0E0E0', // grey lighten-2
        'color-2-5': '#E0E0E0',
        'color-2-6': '#E0E0E0',
        'color-3': '#BDBDBD', // grey lighten-1
        'color-3-5': '#BDBDBD',
        'color-3-5-5': '#BDBDBD',
        'color-4': '#FFFFFF', // grey darken-1  #757575
        'color-5': '#E0E0E0',
        'color-6': '#E0E0E0',
        'color-7': '#E0E0E0',
        'indianred': '#CD5C5C',
        'lightcoral': '#F08080',
        'salmon': '#FA8072',
        'darksalmon': '#E9967A',
        'crimson': '#DC143C',
        'firebrick': '#B22222',
        'darkred': '#8B0000',
        'lightpink': '#FFB6C1',
        'hotpink': '#FF69B4',
        'deeppink': '#FF1493',
        'lightsalmon': '#FFA07A',
        'coral': '#FF7F50',
        'tomato': '#FF6347',
        'orangered': '#FF4500',
        'darkorange': '#FF8C00',
        'gold': '#FFD700',
        'moccasin': '#FFE4B5',
        'peachpuff': '#FFDAB9',
        'palegoldenrod': '#EEE8AA',
        'khaki': '#F0E68C',
        'darkkhaki': '#BDB76B',
        'lavender': '#E6E6FA',
        'thistle': '#D8BFD8',
        'plum': '#DDA0DD',
        'violet': '#EE82EE',
        'magenta': '#FF00FF',
        'mediumorchid': '#BA55D3',
        'mediumpurple': '#9370DB',
        'slateblue': '#6A5ACD',
        'darkslateblue': '#483D8B',
        'greenyellow': '#ADFF2F',
        'chartreuse': '#7FFF00',
        'limegreen': '#32CD32',
        'palegreen': '#98FB98',
        'mediumspringgreen': '#00FA9A',
        'mediumseagreen': '#3CB371',
        'seagreen': '#2E8B57',
        'olive': '#808000',
        'mediumaquamarine': '#66CDAA',
        'lightseagreen': '#20B2AA',
        'aqua': '#00FFFF',
        'steelblue': '#4682B4',
        'lightsteelblue': '#B0C4DE',
        'deepskyblue': '#00BFFF',
        'dodgerblue': '#1E90FF',
        'cornflowerblue': '#6495ED',
        'mediumslateblue': '#7B68EE',
        'royalblue': '#4169E1',
        'navy': '#000080',
        'cornsilk': '#FFF8DC',
        'wheat': '#F5DEB3',
        'burlywood': '#DEB887',
        'rosybrown': '#BC8F8F',
        'sandybrown': '#F4A460',
        'goldenrod': '#DAA520',
        'darkgoldenrod': '#B8860B',
        'chocolate': '#D2691E',
        'saddlebrown': '#8B4513',
        'snow': '#FFFAFA',
        'honeydew': '#F0FFF0',
        'azure': '#F0FFFF',
        'lavenderblush': '#FFF0F5',
        'lightslategray': '#778899',
        'silver': '#C0C0C0',
        'darkslategray': '#2F4F4F'
      },
      dark: {
        primary: '#FFFFFF', // white
        'not-primary': '#000000', // black
        secondary: '#424242',
        'color-0': '#BDBDBD', // grey lighten-1
        'color-1': '#121212', //
        'color-1-5': '#757575', // grey darken-1
        'color-2': '#272727', //
        'color-2-5': '#292929',
        'color-2-6': '#616161', // grey darken-2
        'color-3': '#424242', // grey darken-3
        'color-3-5': '#373737',
        'color-3-5-5': '#303030',
        'color-4':  '#212121', //grey darken-4
        'color-5': '#252525',
        'color-6': '#202020',
        'color-7': '#1E1E1E',
        'indianred': '#CD5C5C',
        'lightcoral': '#F08080',
        'salmon': '#FA8072',
        'darksalmon': '#E9967A',
        'crimson': '#DC143C',
        'firebrick': '#B22222',
        'darkred': '#8B0000',
        'lightpink': '#FFB6C1',
        'hotpink': '#FF69B4',
        'deeppink': '#FF1493',
        'lightsalmon': '#FFA07A',
        'coral': '#FF7F50',
        'tomato': '#FF6347',
        'orangered': '#FF4500',
        'darkorange': '#FF8C00',
        'gold': '#FFD700',
        'moccasin': '#FFE4B5',
        'peachpuff': '#FFDAB9',
        'palegoldenrod': '#EEE8AA',
        'khaki': '#F0E68C',
        'darkkhaki': '#BDB76B',
        'lavender': '#E6E6FA',
        'thistle': '#D8BFD8',
        'plum': '#DDA0DD',
        'violet': '#EE82EE',
        'magenta': '#FF00FF',
        'mediumorchid': '#BA55D3',
        'mediumpurple': '#9370DB',
        'slateblue': '#6A5ACD',
        'darkslateblue': '#483D8B',
        'greenyellow': '#ADFF2F',
        'chartreuse': '#7FFF00',
        'limegreen': '#32CD32',
        'palegreen': '#98FB98',
        'mediumspringgreen': '#00FA9A',
        'mediumseagreen': '#3CB371',
        'seagreen': '#2E8B57',
        'olive': '#808000',
        'mediumaquamarine': '#66CDAA',
        'lightseagreen': '#20B2AA',
        'aqua': '#00FFFF',
        'steelblue': '#4682B4',
        'lightsteelblue': '#B0C4DE',
        'deepskyblue': '#00BFFF',
        'dodgerblue': '#1E90FF',
        'cornflowerblue': '#6495ED',
        'mediumslateblue': '#7B68EE',
        'royalblue': '#4169E1',
        'navy': '#000080',
        'cornsilk': '#FFF8DC',
        'wheat': '#F5DEB3',
        'burlywood': '#DEB887',
        'rosybrown': '#BC8F8F',
        'sandybrown': '#F4A460',
        'goldenrod': '#DAA520',
        'darkgoldenrod': '#B8860B',
        'chocolate': '#D2691E',
        'saddlebrown': '#8B4513',
        'snow': '#FFFAFA',
        'honeydew': '#F0FFF0',
        'azure': '#F0FFFF',
        'lavenderblush': '#FFF0F5',
        'lightslategray': '#778899',
        'silver': '#C0C0C0',
        'darkslategray': '#2F4F4F',

        // HP-Colorpalet (Schnittstelle, hier Anpassbar)
        'hp-color-drk-b07': '#8B98AC',
        'hp-color-drk-b06': '#687589',
        'hp-color-drk-b05': '#576474',   
        'hp-color-drk-b04': '#49525F',  
        'hp-color-drk-b03': '#333A44',  
        'hp-color-drk-b02': '#282D35',  
        'hp-color-drk-b01': '#20242A',  
        // 'hp-color-drk-b01': '#1F242A',  
        'hp-color-drk-b00': '#070809', 

        // 'hp-color-drk-b07': '#72A2E9',
        // 'hp-color-drk-b06': '#6995D6',  
        // 'hp-color-drk-b05': '#6088C3',  
        // 'hp-color-drk-b04': '#5A7FB5',  
        // 'hp-color-drk-b03': '#5576A5',  
        // 'hp-color-drk-b02': '#435E83',  
        // 'hp-color-drk-b01': '#354A67',  
        // 'hp-color-drk-b00': '#27374D', 

        // 'hp-color-drk-b07': '#B9b3ff',
        // 'hp-color-drk-b06': '#a7a1e6',  
        // 'hp-color-drk-b05': '#948fcc',  
        // 'hp-color-drk-b04': '#827db3',  
        // 'hp-color-drk-b03': '#6f6b99',  
        // 'hp-color-drk-b02': '#5d5980',  
        // 'hp-color-drk-b01': '#4a4766',  
        // 'hp-color-drk-b00': '#2e2c40', 
      }
    },
    dark: true
  },
});

// grey lighten-5 #FAFAFA
// grey lighten-4 #F5F5F5
// grey lighten-3 #EEEEEE
// grey lighten-2 #E0E0E0
// grey lighten-1 #BDBDBD
// grey darken-1  #757575
// grey darken-2  #616161
// grey darken-3  #424242
// grey darken-4  #212121
// grey           #9E9E9E
// black          #000000
// white          #FFFFFF
